<script lang="ts">
	import type { EmblaCarouselType } from 'embla-carousel';

	import ThumbnailImage from '$lib/components/ThumbnailImage.svelte';
	import { m } from '$lib/paraglide/messages';
	import Fade from 'embla-carousel-fade';
	import emblaCarouselSvelte, { type EmblaCarouselSvelteType } from 'embla-carousel-svelte';

	import ZoomableImage from './ZoomableImage.svelte';

	let {
		images,
	}: {
		images: string[];
	} = $props();

	let dialog: HTMLDialogElement | undefined;
	let emblaMain = $state<EmblaCarouselType | null>(null);
	let emblaThumbs = $state<EmblaCarouselType | null>(null);
	let startIndex = $state(0);
	let selectedIndex = $state(0);

	function onMainInit(e: CustomEvent<EmblaCarouselSvelteType>) {
		emblaMain = e.detail as EmblaCarouselType;

		emblaMain.on('select', onSelect).on('reInit', onSelect);
	}

	function onThumbsInit(e: CustomEvent<EmblaCarouselSvelteType>) {
		emblaThumbs = e.detail as EmblaCarouselType;
	}

	function onThumbClick(index: number) {
		if (!emblaMain || !emblaThumbs) return;

		selectedIndex = index;
		emblaMain.scrollTo(index);
	}

	function onSelect() {
		if (!emblaMain || !emblaThumbs) return;

		selectedIndex = emblaMain.selectedScrollSnap();
		emblaThumbs.scrollTo(selectedIndex - 1);
	}

	export async function show(index: number) {
		if (!dialog) return;

		startIndex = index;
		dialog.showModal();
	}
</script>

<dialog bind:this={dialog} class="size-full bg-white">
	<button
		type="button"
		class="icon-[mdi--close] absolute top-3 right-3 z-30 size-10 cursor-pointer"
		onclick={() => dialog?.close()}
		aria-label={m.close()}
	></button>

	<div class="flex h-full flex-col p-2">
		<div
			class="flex-1 overflow-hidden"
			use:emblaCarouselSvelte={{
				options: {
					startIndex,
				},
				plugins: [Fade()],
			}}
			onemblaInit={onMainInit}
		>
			<div class="flex h-full touch-pan-y touch-pinch-zoom">
				{#each images as image, i (i)}
					<div class="flex shrink-0 grow-0 basis-full justify-center">
						<ZoomableImage src="product/{image}" class="h-full w-full object-contain" />
					</div>
				{/each}
			</div>
		</div>
		<div
			class="mx-auto h-32 max-w-full overflow-hidden px-4"
			use:emblaCarouselSvelte={{
				options: {
					containScroll: 'trimSnaps',
					startIndex,
					dragFree: true,
					align: 'start',
				},
				plugins: [],
			}}
			onemblaInit={onThumbsInit}
		>
			<div class="flex h-full touch-pan-y touch-pinch-zoom justify-start gap-2 select-none">
				{#each images as image, i (i)}
					<button
						type="button"
						class="shrink-0 grow-0 basis-28 cursor-pointer"
						onclick={() => onThumbClick(i)}
					>
						<ThumbnailImage
							src="product/{image}"
							maxSize={300}
							loading="lazy"
							class={[
								'mx-auto h-28 object-cover',
								{
									'outline-2  outline-black': i === selectedIndex,
								},
							]}
						/>
					</button>
				{/each}
			</div>
		</div>
	</div>
</dialog>
